import React from 'react'
import { useForm } from 'react-hook-form'
import CrudEdit from '~/components/CrudEdit'
import IWeaponKind from '../interfaces/IWeaponBrand'
import Layout from '~/components/Layout'

export default function Edit() {
  const {
    register,
    handleSubmit,
    control,
    setValue: setFormValue,
    getValues,
  } = useForm<IWeaponKind>()

  const fields = [
    { name: 'id', type: 'hidden' },
    { name: 'name', type: 'string' },
  ]

  return (
    <Layout marginLayout={true}>
      <CrudEdit
        model={'weapon-brand'}
        fields={fields}
        register={register}
        handleSubmit={handleSubmit}
        control={control}
        setFormValue={setFormValue}
        messageSuccess={'Weapon brand successfully updated!'}
        title={'Edit weapon brand'}
        getValues={getValues}
      />
    </Layout>
  )
}
